/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = ReadyToStart
 *
 * 2 = InProcess
 *
 * 3 = Completed
 */
export enum QuestionsStatusEnum {
  ReadyToStart = 1,
  InProcess = 2,
  Completed = 3,
}
